import { TOS_VERSION, TOS_PREAMBLE, TOS_SECTIONS, TOS_FOOTER } from '../legal/terms';
import styles from './TermsPage.module.css';

const renderParagraphs = (text: string): ReadonlyArray<React.ReactElement> =>
  text.split('\n\n').map((paragraph, idx) => (
    <p key={idx} className={styles.sectionBody}>{paragraph}</p>
  ));

const TermsPage = (): React.ReactElement => (
  <div className={styles.container}>
    <h1 className={styles.title}>EVENT.BLACK Terms of Service</h1>
    <p className={styles.version}>Last Updated: {TOS_VERSION}</p>
    <p className={styles.sectionBody}>{TOS_PREAMBLE}</p>
    {TOS_SECTIONS.map((section) => (
      <section key={section.heading} className={styles.section}>
        <h2 className={styles.sectionHeading}>{section.heading}</h2>
        {renderParagraphs(section.body)}
      </section>
    ))}
    <hr className={styles.divider} />
    {renderParagraphs(TOS_FOOTER)}
  </div>
);

export { TermsPage };
